import React, { useEffect, useState, createContext } from "react";

import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";

// defaultTheme
import theme from "./theme";

// routing
import Routes from "./routes";
import { AppContext } from "./hooks/AppContext";

const App = () => {
  const [appState, setAppState] = useState({
    initialAppLoading: true,
    isStateDataLoading: false,
    statesData: {},
    stateSelected: "",
    sourceSelected: "",
  });

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme()}>
        <CssBaseline />
        <AppContext.Provider value={{ appState, setAppState }}>
          <Routes />
        </AppContext.Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
